import { FormRadioGroup } from "@/components/basic/FormRadioGroup";

type Props = {
  selectValue?: string;
  setFieldValue: Function;
  name?: string;
  defaultClearValue?: string | number;
  allowClearSelected?: boolean;
  errorMsg?: string;
  radios: {
    name?: string;
    value?: string;
    icon: string;
    title: string;
    description: string;
    price: string;
  }[];
};

const parsePrice = (raw: string): { leading?: string; amount: string } => {
  if (!raw) return { amount: "" };
  const trimmed = raw.trim();
  if (/^FREE$/i.test(trimmed)) return { amount: "FREE" };
  const match = trimmed.match(/^(Only\s+)?(.+)$/i);
  if (match) {
    return {
      leading: match[1] ? match[1].trim() : undefined,
      amount: match[2].trim(),
    };
  }
  return { amount: trimmed };
};

export const CheckoutCardRadios = ({
  name = "",
  selectValue,
  setFieldValue,
  defaultClearValue,
  allowClearSelected,
  errorMsg,
  radios,
}: Props) => {
  return (
    <FormRadioGroup
      value={selectValue}
      radios={radios}
      name={name}
      errorMsg={errorMsg}
      renderContent={(renderOption: any, isSelected: boolean) => {
        const price = parsePrice(renderOption.price);
        const isFree = price.amount === "FREE";
        return (
          <div className="flex items-start gap-4 p-5 pr-14">
            <div
              className="flex-shrink-0 w-12 h-12 rounded-lg flex items-center justify-center"
              style={{
                backgroundColor: isSelected ? "#e1f1e3" : "#f3f4f6",
                color: isSelected ? "#358639" : "#374151",
              }}
              aria-hidden="true"
            >
              <svg
                width="26"
                height="26"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <polyline points="20 12 20 22 4 22 4 12" />
                <rect x="2" y="7" width="20" height="5" />
                <line x1="12" y1="22" x2="12" y2="7" />
                <path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z" />
                <path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z" />
              </svg>
            </div>
            <div className="flex-1 text-left min-w-0">
              <div className="flex items-baseline flex-wrap gap-x-3 gap-y-1">
                <h3
                  className="font-bold text-base"
                  style={{ color: "#0f1111" }}
                >
                  {renderOption.title}
                </h3>
                <span
                  className="font-bold text-base"
                  style={{ color: isFree ? "#358639" : "#0f1111" }}
                >
                  {price.leading && (
                    <span
                      className="font-normal text-sm mr-1"
                      style={{ color: "#6b7280" }}
                    >
                      {price.leading}
                    </span>
                  )}
                  {price.amount}
                </span>
              </div>
              <p
                className="text-xs mt-1.5 leading-relaxed"
                style={{ color: "#565959" }}
                dangerouslySetInnerHTML={{ __html: renderOption.description }}
              />
            </div>
          </div>
        );
      }}
      onChange={(e) => {
        const value = (e.target as HTMLInputElement).value;
        setFieldValue(name, value);
      }}
      onClickSelected={() => {
        if (allowClearSelected) {
          setFieldValue(name, defaultClearValue || "");
        }
      }}
    />
  );
};
